import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
})
export class AlertDialogComponent {
  title: string;
  message: string;
  messageList: string[];

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogModel
  ) {
    this.title = data.title;

    this.message = data.message;
    this.messageList = data.messageList;

    if (this.message && this.message.includes('\n')) {
      this.messageList = this.message.split('\n');
      this.message = '';
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

export class AlertDialogModel {
  constructor(
    public title: string,
    public message: string,
    public messageList: string[]
  ) {}
}
